import { useState } from 'react';

import { APP_URLS, PLATFORM_TYPE } from '../../app/constants/constants';
import { UseGetFlag } from '../../app/launchDarkly';
import useCheckNative from '../../hooks/utils/useCheckNative';
import { appStore, isStandaloneMode } from '../../utils/os.utils';
import InstallPrompt from './InstallPrompt';

const InstallApp = () => {
  const isNativeApp = useCheckNative();
  const isEmbeddedApp = isNativeApp || isStandaloneMode;
  const { shouldShowBanner } = UseGetFlag();
  const [isInstallBannerClosed, setIsInstallBannerClosed] = useState(
    sessionStorage.getItem('installBannerClosed') === 'true'
  );
  const setInstallBannerToSessionStorage = (value: boolean) => {
    sessionStorage.setItem('installBannerClosed', String(value));
    setIsInstallBannerClosed(value);
  };
  const handleInstallClick = () => {
    appStore();
  };
  const shouldShowInstallPrompt =
    !isEmbeddedApp && shouldShowBanner && !isInstallBannerClosed;
  return (
    <>
      {shouldShowInstallPrompt && (
        <InstallPrompt
          onInstallClick={handleInstallClick}
          setInstallBannerToSessionStorage={setInstallBannerToSessionStorage}
        />
      )}
    </>
  );
};

export default InstallApp;
